import api from './axios';

export const getNotificationPreferences = async () => {
  const res = await api.get('/user/notification-preferences');
  return res.data;
};

export const updateNotificationPreferences = async (role, prefs) => {
  const res = await api.put('/user/notification-preferences', {
    role,
    prefs,
  });
  return res.data;
};
